import { Container, Divider, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import * as React from 'react';
import SchoolIcon from '@mui/icons-material/School';
import { Button, Link } from '@mui/material';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';


const Qualifications = () => {
    const [state, setState] = React.useState({
        open: false,
        defer: false,
    });
    return (
        <Box id="qualifications" sx={{ flexGrow: 1, px: { xs: '10px', md: '0px' }, py: { xs: 150, md: 10 }, mt: { xs: '-1100px', md: '0px' } }}>
            <Container sx={{ textAlign: 'center', }}>
                <Typography sx={{ fontWeight: 500, letterSpacing: '2px', mb: '3px' }} variant="h6" component="div">
                    CERTIFICATIONS
                </Typography>
                <Divider sx={{ width: '100px', p: 0, m: '-2px auto', border: '1px solid #FFFFFF4E' }} />
                <Divider sx={{ width: '150px', p: 0, m: '4px auto', border: '1px solid #FFFFFF4E' }} />
                <Box sx={{ textAlign: 'center', my: 5 }}>
                    <Link data-aos="fade-up"
                        data-aos-easing="ease-out-cubic"
                        data-aos-duration="1500"
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255, 255, 255, 0.689)', }}
                        href="#" underline="none">
                        <SchoolIcon sx={{ fontSize: '30px' }} />
                        <Typography sx={{ fontWeight: 400, letterSpacing: '1px', mx: 2 }} variant="p" component="div">
                            Sheikh kamal incubation and training center: Wordpress Theme Customizaion
                        </Typography>
                    </Link>

                    <Link data-aos="fade-up"
                        data-aos-easing="ease-out-cubic"
                        data-aos-duration="1500"
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255, 255, 255, 0.689)', mt: { xs: 1, md: 0 } }}
                        href="https://drive.google.com/file/d/1mx4WA02F8Y2Tsd2euuJLB65krbpE9owt/view"
                        target="_blank"
                        underline="none">
                        <SchoolIcon sx={{ fontSize: '30px' }} />
                        <Typography sx={{ fontWeight: 400, letterSpacing: '1px', mx: 2 }} variant="p" component="div">
                            Programming Hero: MERN Stack Development
                        </Typography>
                    </Link>

                    <Button
                        data-aos="fade-up"
                        data-aos-easing="ease-out-cubic"
                        data-aos-duration="1500"
                        style={{ textTransform: 'capitalize', backgroundColor: 'transparent', border: '1px solid #FFFFFF4E', color: 'rgba(255, 255, 255, 0.689)', fontSize: '15px', marginTop: '10px' }}
                        type="button"
                        variant="contained"
                        onClick={() =>
                            setState({
                                open: !state.open,
                                defer: false,
                            })
                        }
                    >
                        <ArrowCircleDownIcon sx={{ fontSize: '18px' }} /> <span style={{ marginTop: '1px', marginLeft: '5px' }}>Academic</span>

                    </Button>


                    <Box sx={{ marginTop: '20px' }}>
                        {state.open ? (
                            <Grid sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 3, boxShadow: 5, }} container spacing={{ xs: 1, md: 1 }} columns={{ xs: 4, sm: 8, md: 12 }}>

                                <Grid sx={{ py: 2, px: 2, mt: { sx: 2, md: 0 }, bgcolor: '#80808000', border: '1px solid #FFFFFF4E', borderRadius: '3px', boxShadow: 5, mx: 1, color: 'rgba(255, 255, 255, 0.689)', }} item xs={1.8} sm={2} md={2.8}>
                                    <Typography sx={{ fontWeight: 500, border: '1px solid #f5f5f530', borderRadius: '3px', mt: 2, ml: 1 }} variant="h6" component="div">
                                        SSC
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', p: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        School: Dudmukha High School
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', py: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        Year: 2011
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', py: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        Group: Science
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', py: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        GPA: 5.00
                                    </Typography>
                                </Grid>

                                <Grid sx={{ py: 2, px: 2, mt: { sx: 2, md: 0 }, bgcolor: '#80808000', border: '1px solid #FFFFFF4E', borderRadius: '3px', boxShadow: 5, mx: 1, color: 'rgba(255, 255, 255, 0.689)', }} item xs={1.8} sm={2} md={2.8}>
                                    <Typography sx={{ fontWeight: 500, border: '1px solid #f5f5f530', borderRadius: '3px', mt: 2, ml: 1 }} variant="h6" component="div">
                                        HSC
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', p: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        College: Iqbal Memorial College
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', py: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        Year: 2013
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', py: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        Group: Science
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', py: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        GPA: 5.00
                                    </Typography>
                                </Grid>

                                <Grid sx={{ py: 2, px: 2, mt: { xs: 2, md: 0 }, bgcolor: '#80808000', border: '1px solid #FFFFFF4E', borderRadius: '3px', boxShadow: 5, mx: 1, color: 'rgba(255, 255, 255, 0.689)', }} item xs={1.8} sm={2} md={2.8}>
                                    <Typography sx={{ fontWeight: 500, border: '1px solid #f5f5f530', borderRadius: '3px', mt: 2, ml: 1 }} variant="h6" component="div">
                                        B.Sc (Engg.)
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', p: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        University: Comilla University
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', py: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        Year: 2020
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', py: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        Dept: Information & Communication Technology
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', py: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        CGPA: 3.15
                                    </Typography>
                                </Grid>

                                <Grid sx={{ py: 2, px: 2, mt: { xs: 2, md: 0 }, bgcolor: '#80808000', border: '1px solid #FFFFFF4E', borderRadius: '3px', boxShadow: 5, mx: 1, color: 'rgba(255, 255, 255, 0.689)', }} item xs={1.8} sm={2} md={2.8}>
                                    <Typography sx={{ fontWeight: 500, border: '1px solid #f5f5f530', borderRadius: '3px', mt: 2, ml: 1 }} variant="h6" component="div">
                                        M.Sc (Engg.)
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', p: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        University: Comilla University
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', py: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        Year: N/A
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', py: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        Dept: Information & Communication Technology
                                    </Typography>
                                    <Typography sx={{ fontWeight: 300, border: '1px solid #f5f5f530', borderRadius: '3px', py: 1, mt: 2, ml: 1 }} variant="p" component="div">
                                        CGPA: N/A
                                    </Typography>
                                </Grid>


                            </Grid>
                        ) : null}
                    </Box>
                </Box>

                {/* <Typography sx={{ fontWeight: 400, letterSpacing: '1px' }} variant="h6" component="div">
                    Skill concentration : Full-Stack Development
                </Typography> */}
            </Container>
        </Box>
    );
};

export default Qualifications;